import React, { useContext, useEffect, useState } from 'react'
import { LoadingFull, LoadingOverlay } from '../../loading';
import axios from 'axios';
import { UserContext } from '../../../App';
import { FiEdit } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";

const Transactions = ({stripeUser}) => {

  const [load, setLoad] = useState(false)
  const [error, setError] = useState('')
  const { auth, user } = useContext(UserContext)
  const token = localStorage.getItem('token')
  
  const getDate = (unixTime) => {
    const date = new Date(unixTime * 1000); // Konverterer sekunder til millisekunder

    // Formater kun datoen
    const dateOptions = {
      day: 'numeric',
      month: 'short', // Kun de første tre bogstaver af måneden
      year: 'numeric',
    };

    // Formater kun tiden
    const timeOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false, // 24-timers format
    };

    const datePart = date.toLocaleDateString('da-DK', dateOptions);
    const timePart = date.toLocaleTimeString('da-DK', timeOptions);
    
    return `d. ${datePart}, kl. ${timePart}`
  }

  return (
    <div className="w-full h-fit lg:h-full border border-gray-100 shadow-lg relative">
      {(load) ?
        <LoadingOverlay />
      :
        ""}
      <div className="h-full bankInfo px-10 py-5 flex flex-col justify-center gap-2">
          <div className="flex flex-col gap-5">
            <h2 className="font-semibold text-sm md:text-base">Transaktioner</h2>
            {(typeof stripeUser !== 'undefined') ?
              <div className="transactions">
                {((Object.keys(stripeUser.transactions).length !== 0) > 0) ?
                  <>
                    <table class="table-auto w-full text-left hidden md:inline-table">
                      <thead className="text-sm">
                        <tr>
                          <th className="pb-4 font-semibold hidden sm:block">Beløb</th>
                          <th className="pb-4 font-semibold">Status</th>
                          <th className="pb-4 font-semibold">Handling</th>
                          <th className="text-end pb-4 font-semibold">Dato</th>
                        </tr>
                      </thead>
                      <tbody className="text-base">
                        {stripeUser.transactions.data.map((trans) => {
                          return (
                            <tr className="border-t">
                              <td className="py-4 font-medium">{Number(trans.amount/100).toFixed(2).toString().replace(/\./g, ',')} kr.</td>
                              <td className="py-4">
                                <div className="px-2 py-1 text-sm bg-gradient-to-r from-emerald-200 to-emerald-300 bg-size-200 bg-pos-0 text-emerald-800 font-medium w-fit">
                                  Gennemført
                                </div>
                              </td>
                              <td className="py-4">{(trans.reporting_category === 'payout' ? "Udbetaling" : "Overførsel til saldo")}</td>
                              <td className="text-end py-4 hidden sm:block">{getDate(trans.created)}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                    <div className="flex flex-col md:hidden">
                      <hr></hr>
                      {stripeUser.transactions.data.map((trans) => {
                        return (
                          <>
                          <div className="flex py-5 ">
                            <div className="details flex flex-col gap-2">
                              <div className="px-2 py-1 text-sm bg-gradient-to-r from-emerald-200 to-emerald-300 bg-size-200 bg-pos-0 text-emerald-800 font-medium w-fit">
                                Gennemført
                              </div>
                              <div className="">
                                <p className="text-sm text-neutral-500">{(trans.reporting_category === 'payout' ? "Udbetaling" : "Overførsel til saldo")}</p>
                                <h2 className="font-medium">{Number(trans.amount/100).toFixed(2).toString().replace(/\./g, ',')} kr.</h2>
                              </div>
                              <p className="text-xs text-neutral-500">{getDate(trans.created)}</p>
                            </div>
                          </div>
                          <hr></hr>
                          </>
                        )
                      })}
                    </div>
                  </>
                :
                  <p className="text-neutral-500 italic">Der er ingen transaktioner</p>}
              </div>
            :
              <LoadingFull />
            }
          </div>
      </div>
    </div>
  )
}

export default Transactions